module.exports = __webpack_public_path__ + "static/media/plant_sun.652c46ec.png";